// extracted by mini-css-extract-plugin
module.exports = {"select":"styles_select__367Gp","address":"styles_address__3aa7O"};